<div class="full-height page-pull-container">
  <ng-content></ng-content>
</div>
